"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoCodeConstants = void 0;
exports.promoCodeConstants = {
    FIRST_ENTRY_DISCOUNT_CODE: 'FIRSTENTRY50OFF',
};
//# sourceMappingURL=dbConstants.js.map